import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Accueil', path: '/' },
  { label: 'À propos', path: '/a-propos' },
  { label: 'Contact', path: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-20">
        <Link to="/" className="flex items-center">
          <img
            src="https://public.readdy.ai/ai/img_res/8259da15-e112-4849-b454-da1593529b79.png"
            alt="SOMINKA"
            className="h-10 w-auto"
          />
        </Link>

        <ul className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className={`text-sm font-medium tracking-wide transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-[#1A2B4A] border-b-2 border-[#1A2B4A] pb-0.5'
                    : scrolled || !isHome
                    ? 'text-gray-600 hover:text-[#1A2B4A]'
                    : 'text-white/90 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="hidden md:block">
          <Link
            to="/contact"
            className="px-6 py-2.5 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer bg-[#1A2B4A] text-white hover:bg-[#243a5e]"
          >
            Nous contacter
          </Link>
        </div>

        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${
            scrolled || !isHome ? 'text-[#1A2B4A]' : 'text-white'
          }`}
          aria-label="Menu"
        >
          <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
        </button>
      </nav>

      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-5 shadow-sm">
          <ul className="flex flex-col gap-5">
            {navLinks.map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className="text-sm font-medium text-gray-700 hover:text-[#1A2B4A] transition-colors cursor-pointer"
                >
                  {link.label}
                </Link>
              </li>
            ))}
            <li>
              <Link
                to="/contact"
                className="inline-block px-6 py-2.5 text-sm font-medium rounded-full bg-[#1A2B4A] text-white whitespace-nowrap cursor-pointer"
              >
                Nous contacter
              </Link>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
